import { DonationBatchPage } from './DonationBatchPage';

export function DonationAccountsPage() {
  return <DonationBatchPage panel="accounts" title="Market Promotion Accounts Adjust" />;
}
